import { render, staticRenderFns } from "./SmsDeliveryStatus.vue?vue&type=template&id=6dfaf2f2&scoped=true"
import script from "./SmsDeliveryStatus.vue?vue&type=script&lang=js"
export * from "./SmsDeliveryStatus.vue?vue&type=script&lang=js"
import style0 from "./SmsDeliveryStatus.vue?vue&type=style&index=0&id=6dfaf2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfaf2f2",
  null
  
)

export default component.exports